import React from "react";
import styles from "./Spinner2.module.css";
const Spinner2 = () => {
  return <div className={styles.spin} />;
};

export default Spinner2;
